//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'feedback',
  data: function data() {
    return {
      show: false
    };
  },
  components: {},
  computed: {},
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showMethod: function showMethod(type) {
      this.show = type;
      this.$refs.feedbackAdd.editInit();
    }
  },
  mounted: function mounted() {},
  created: function created() {}
};